// extracted by mini-css-extract-plugin
export default {"container":"Jn-z","blurb":"Kn-z","links":"Ln-z"};